import { render, staticRenderFns } from "./RaporList.vue?vue&type=template&id=bf1b2fb2&scoped=true"
import script from "./RaporList.vue?vue&type=script&lang=ts"
export * from "./RaporList.vue?vue&type=script&lang=ts"
import style0 from "./RaporList.vue?vue&type=style&index=0&id=bf1b2fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1b2fb2",
  null
  
)

export default component.exports